export const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result.toString());
        } else {
          reject(new Error("Failed to convert file to Base64."));
        }
      };
      reader.onerror = (error) => reject(error);
    });
  };

  export const labelMapping = {
    // Home Section
    home: "Home",
    home_sections: "Home Sections",
    hero: "Hero Section",
    aboutus: "About Us Section",
    room: "Room Section",
    offer: "Offer Section",
    services: "Services Section",
    testimonials: "Testimonials",
    blogs: "Blogs Section",
  
    // About Us Section
    about_us: "About Us",
    abutus_sections: "About Us Sections",
    about_section: "About Section",
    about_counter: "About Counter",
    about_team: "About Team",
  
    // Room Suites Section
    room_suits: "Room Suites",
    room_suits_sections: "Room Suites Sections",
    room_list: "Room List",
    masonry_gallery: "Masonry Gallery",
  
    // Dining Section
    dinning: "Dining",
    dinning_sections: "Dining Sections",
    dinning_card: "Dining Card",
    dinning_details: "Dining Details",
    food_menu: "Food Menu",
  
    // Meeting & Events Section
    meeting_events: "Meeting & Events",
    meeting_events_sections: "Meeting & Events Sections",
    event_plan: "Event Plan",
    venue: "Venue",
  
    // Other Sections
    amenities: "Amenities",
    career: "Career",
    faq: "FAQ",
    gallery: "Gallery",
    contact: "Contact",
  };
  
  